import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AutoComplete from 'material-ui/AutoComplete';
import RaisedButton from 'material-ui/RaisedButton';

import { updateVesselSize } from 'actions/vessels/size';
import api from 'services';

class VesselShortInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            vesselNames: [],
            vesselName: props.vesselSize.vesselName,
            imoNumber: props.vesselSize.imoNumber,
            DWT: props.vesselSize.DWT,
            BLT: props.vesselSize.BLT,
        };

        this.dAutocomplete = _.debounce((searchText) => {
            if (searchText) {
                api.findVessel(searchText)
                    .then((response) => {
                        const vesselNames = response.data.data.map(vessel => ({
                            name: `${vessel.name} (imoNumber - ${vessel.imoNumber})`,
                            item: vessel,
                        }));

                        this.setState({
                            vesselNames,
                        });
                    })
                    .then(() => {
                        const newVesselSize = _.cloneDeep(this.props.vesselSize);
                        newVesselSize.vesselName = searchText;
                        this.props.updateVesselSize(this.props.numberSizeTable, newVesselSize);
                    })
                    .catch(() => null);
            }
        }, 1000);

        this.chooseVessel = this.chooseVessel.bind(this);
        this.changeVesselName = this.changeVesselName.bind(this);
    }

    dAutocomplete(searchText) {
        
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            vesselName: nextProps.vesselSize.vesselName,
            imoNumber: nextProps.vesselSize.imoNumber,
            DWT: nextProps.vesselSize.DWT,
            BLT: nextProps.vesselSize.BLT,
        });
    }

    changeVesselName(searchText) {
        // check if the searchText has only the vessel name
        if (searchText.includes('(imoNumber')) {
            return;
        }
        if (this.state.vesselName !== searchText) {
            this.setState({
                vesselName: searchText,
            }, () => {
                this.dAutocomplete(searchText);
            });
        }
    }

    chooseVessel(updateProperties) {
        if (!updateProperties) {
            return;
        }

        const newVesselSize = _.cloneDeep(this.props.vesselSize);

        newVesselSize.vesselName = updateProperties.name;
        newVesselSize.vessel = updateProperties.item._id;
        newVesselSize.imoNumber = updateProperties.item.imoNumber;
        newVesselSize.DWT = updateProperties.item.dw.summer;
        newVesselSize.BLT = updateProperties.item.blt;

        this.props.updateVesselSize(this.props.numberSizeTable, newVesselSize);

        this.setState({
            imoNumber: updateProperties.item.imoNumber,
            DWT: updateProperties.item.dw.summer,
            BLT: updateProperties.item.blt,
        });
    }

    render() {
        const errorVesselName = this.props.errorVesselName ? this.props.errorVesselName.messages[0] : '';
        const {
            vesselNames, vesselName, imoNumber, DWT, BLT, 
        } = this.state;

        return (
            <div style={{ marginTop: '-30px' }}>
                <div className='sidebar-table'>
                    <div className='row'>
                        <div className='column-left'>
                            Vessel name:
                        </div>
                        <div className='column-right'>
                            <AutoComplete 
                                name='vesselName'
                                textFieldStyle={{ fontSize: '13px' }}
                                hintText='Vessel name'
                                errorText={errorVesselName}
                                searchText={vesselName || ''}
                                dataSource={vesselNames}
                                dataSourceConfig={{ text: 'name', value: 'item' }}
                                onUpdateInput={this.changeVesselName}
                                onNewRequest={this.chooseVessel}
                                filter={AutoComplete.noFilter}
                                fullWidth
                                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                popoverProps={{
                                    canAutoPosition: true,
                                }}
                            />
                        </div>
                    </div>

                    <div className='row'>
                        <div className='column-left'>
                            imoNumber:
                        </div>
                        <div className='column-right'>
                            <div className='label'>
                                {imoNumber}
                            </div>    
                        </div>
                    </div>
                    <div className='row'>
                        <div className='column-left'>
                            DWT:
                        </div>
                        <div className='column-left'>
                            {DWT}
                        </div>
                    </div>
                    <div className='row'>
                        <div className='column-left'>
                            BLT:
                        </div>
                        <div className='column-left'>
                            {BLT}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const errorVesselName = state.vesselSizes.items[ownProps.numberSizeTable].validateErrors
            .find(validateError => validateError.field === 'vessel');

        return {
            numberSizeTable: ownProps.numberSizeTable,
            errorVesselName,
            vesselSize: state.vesselSizes.items[ownProps.numberSizeTable],
        };
    },
    dispatch => bindActionCreators({
        updateVesselSize,
    }, dispatch),
)(VesselShortInfo);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Size/Sidebar/Size/VesselShortInfo.jsx